import PermissionsListContainer from './permissions_list_container';

const PermissionsList = PermissionsListContainer;

export default PermissionsList;
